import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinnerThird, faPhone } from '@fortawesome/pro-light-svg-icons';
import { faCheck, faExclamationCircle, faExclamationTriangle, faInfo } from '@fortawesome/pro-solid-svg-icons';
import { HioUserinfoEntryComponent } from './hio-userinfo-entry/hio-userinfo-entry.component';
import { HioShareBasicModule } from '@hio/share-basic';
import { HioUserinfoComponent } from './hio-userinfo.component';



@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    HioShareBasicModule,
    HioUserinfoEntryComponent,
    HioUserinfoComponent,
  ],
  exports: [
    HioShareBasicModule,
    HioUserinfoEntryComponent,
    HioUserinfoComponent,
  ]
})
export class HioUserinfoModule {
  constructor(library: FaIconLibrary) {
    // light
    library.addIcons(faCheck, faExclamationCircle, faExclamationTriangle, faInfo, faPhone, faSpinnerThird);
  }
}
